import React, { useContext } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { INTERVIEW_TYPES_OPTIONS } from 'components/Interview/interviewConstants';
import { isObserver } from 'constants/UserRoles';

import { OnlineInterviewContext } from 'context/OnlineInterview/OnlineInterviewContext';
import { InterviewStorageContext } from 'context/Interview/storage/InterviewStorageContext';

import style from './InterviewTabs.module.scss';

const InterviewTab = ({ onClick, active }) => {
    const { t } = useTranslation();
    const { interview } = useContext(InterviewStorageContext);
    const { usersState, isOwner, timeout } = useContext(OnlineInterviewContext);
    const { sessionId } = useParams();
    if (!interview) return null;
    const session = interview.sessions.find((session) => session._id === sessionId);
    if (!session) return null;

    return (
        <div className={cn(style.tab, { [style.active]: active })} onClick={onClick}>
            {t('common.interview')}{' '}
            {isOwner && (
                <div className={cn(style.interviewCount, { [style.active]: active })}>
                    {usersState.users.filter((user) => !isObserver(user.role)).length + timeout.length}/
                    {getParticipantsLimit(interview, session)}
                </div>
            )}
        </div>
    );
};

export const getParticipantsLimit = (interview, session) => {
    if (!interview || !session) return 0;
    if (interview.type === INTERVIEW_TYPES_OPTIONS[1].value) {
        return interview.translation.realTime.translation ? 3 : 2;
    }

    if (interview.translation.realTime.translation) {
        return session.numberOfRespondents + 2;
    }
    return session.numberOfRespondents + 1;
};

InterviewTab.defaultProps = {
    onClick: (f) => f,
    active: false,
};

export default InterviewTab;
